<div class="download-dialog">
  <h2 mat-dialog-title> Richiesta inviata! </h2>
  
  <mat-dialog-content>
    <p>
      Abbiamo ricevuto la tua richiesta.
    </p>

    <!-- Check icon conditionally displayed -->
    <!-- <div class="check-icon-container" *ngIf="data.documentType"> -->
    <div class="success-container">
      <mat-icon class="success-icon mb-3" color="primary">verified</mat-icon>
    </div>

    <p>
      Cosa devi fare ora?
    </p>

    <div class="info-list">
      <div class="info-item">
        <mat-icon class="info-icon">schedule</mat-icon>
        <p>Attendi che la richiesta venga elaborata dai nostri Commercialisti.</p>
      </div>
      
      <div class="info-item">
        <mat-icon class="info-icon">phone_in_talk</mat-icon>
        <p>Contatteremo la persona da te presentata per una call conoscitiva, per assicurarci che abbia tutti i requisiti.</p>
      </div>
      
      <div class="info-item">
        <mat-icon class="info-icon">discount</mat-icon>
        <p>Durante la creazione dell'account, il presentato otterrà un <strong>codice sconto immediato</strong> da usare durante il pagamento del canone annuale.</p>
      </div>
      
      <div class="info-item">
        <mat-icon class="info-icon">card_giftcard</mat-icon>
        <p>Una volta completata la creazione dell'account del presentato, ti invieremo automaticamente una mail con un buono del valore di <strong>30€</strong>, da spendere subito.</p>
      </div>
    </div>

  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <!-- <button 
      mat-button 
      (click)="closeDialog()"
      class="close-button">
      Chiudi
    </button> -->
    
    <button 
      mat-raised-button 
      color="primary" 
      class="download-button"
      (click)="confirm()">
      <mat-icon>check</mat-icon>
      Fatto!
    </button>
  </mat-dialog-actions>
</div>


